import type { SVGProps } from 'react'

const InfoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <circle cx={12} cy={12} r={9.75} stroke="currentColor" strokeWidth={1.5} />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 8.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm0 1.25a1.25 1.25 0 0 1 1.25 1.25V17a1.25 1.25 0 1 1-2.5 0v-5a1.25 1.25 0 1 1 0-2.5H12Z"
      clipRule="evenodd"
    />
  </svg>
)
export default InfoIcon
